import { createNoAuthenticationClient } from "@/http-client";
import { AxiosInstance, AxiosResponse } from 'axios';
import {prefixBaseUrlOneApi} from "@/helper";

export class LandingPageContentService {

    constructor(private client : AxiosInstance) {
        this.client = client;
    }

    async GetCandidateReferencesFinance(): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/kandidaten/LandingPageContent/candidate-references-finance");
    }

    async GetCandidateReferencesTech(): Promise<AxiosResponse> {
        return await this.client.get(prefixBaseUrlOneApi + "/kandidaten/LandingPageContent/candidate-references-tech");
    }

}

export async function createLandingPageContentService(): Promise<LandingPageContentService> {
    const client = await createNoAuthenticationClient();
    return new LandingPageContentService(client);
}
